<template>
  <div class="section-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <table-search
        add-text="新增科室"
        :style="{ float: 'right' }"
        @onSearch="onSearch"
        @editAndAdd="handleAdd"
      />
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :pagination="false"
        children-column-name="child_list"
        :row-key="record => record.id"
      >
        <template
          slot="list_order"
          slot-scope="text, record"
        >
          <editable-cell
            :text="text"
            @change="onCellChange(record.id, 'list_order', $event)"
          />
        </template>
        <template
          slot="status"
          slot-scope="text, record"
        >
          <a-tag color="blue">
            {{ record.status===1?'启用':'禁用' }}
          </a-tag>
          <a-tag
            v-if="record.parent_id!==0"
            color="blue"
          >
            {{ record.is_top===1?'置顶':'未置顶' }}
          </a-tag>
        </template>
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            v-if="record.parent_id===0"
            href="javascript:;"
            @click="() => handleAdd(record)"
          >添加子科室</a>
          <a-divider
            v-if="record.parent_id===0"
            type="vertical"
          />
          <a
            href="javascript:;"
            @click="() => handleEdit(record)"
          >编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            :text="record.status===1?'禁用':'启用'"
            :alert-title="record.status===1?'确定禁用？':'确定启用？'"
            @onDelete="() => onConfirm(record)"
          />
          <a-divider type="vertical" />
          <popconfirm-button
            v-if="record.parent_id!==0"
            :text="record.is_top===1?'取消置顶':'置顶'"
            :alert-title="record.is_top===1?'确定取消置顶？':'确定置顶？'"
            @onDelete="() => onTop(record)"
          />
          <a-divider
            v-if="record.parent_id!==0"
            type="vertical"
          />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
    <add-edit-modal
      ref="formRef"
      :title="title"
      :visible="visible"
      :disabled="disabled"
      :btn-is-loading="btnIsLoading"
      @onCancel="onCancel"
      @handleSubmit="handleSubmit"
    />
  </div>
</template>
<script>
import {columns} from './data/index';
import addEditModal from './modal/index';
export default {
  components: { addEditModal},
  data() {
    return {
      columns,
      data: [],
      loading: false,
      btnIsLoading: false,
      title: '',
      visible: false,
      disabled: true,
      id: '',
    };
  },
  mounted() {
    // 获取表格数据
    this.getTableData({keyword: this.keyword});
  },
  methods: {
    // 递归处理
    dealData(data){
      data.forEach((item)=>{
        if(item.child_list&&item.child_list.length>0){
          this.dealData(item.child_list);
        }else{
          item.child_list=undefined;
        }
      });
      return data;
    },
    // 获取表格数据
    async getTableData(params) {
      this.loading=true;
      let result = await this.$http.post('/department/adminGetList', params);
      if (result.data.status===1) {
        this.loading = false;
        let data = result.data.data.data_list;
        this.data = this.dealData(JSON.parse(JSON.stringify(data)));
      }
    },
    // 搜索
    onSearch(value) {
      this.current=1;
      this.keyword=value;
      this.getTableData({ keyword: this.keyword});
    },
    // 新增、子科室
    handleAdd(record) {
      console.log('TCL: editAndAdd -> record', record);
      this.visible=true;
      this.disabled=true;
      this.id='';
      if(!record){
        this.title='新增科室';
        this.$nextTick(() => {
          this.$refs.formRef.$refs.basicForm.form.setFieldsValue({parent_id: 0, name: undefined, list_order: undefined});
        });
      }else{
        this.title='新增子科室';
        this.$nextTick(() => {
          this.$refs.formRef.$refs.basicForm.form.setFieldsValue({parent_id: record.id, name: undefined, list_order: undefined});
        });
      }
    },
    // 编辑
    handleEdit(record){
      console.log('TCL: handleEdit -> record', record);
      this.visible=true;
      this.disabled=false;
      this.title='编辑科室';
      this.id=record.id;
      let data={
        parent_id: record.parent_id,
        name: record.name,
        list_order: record.list_order,
      };
      this.$nextTick(() => {
        this.$refs.formRef.$refs.basicForm.form.setFieldsValue(data);
      });
    },
    // 确定编辑或新增
    handleSubmit() {
      this.$refs.formRef.$refs.basicForm.form.validateFields(
        async(err, values) => {
          if (!err) {
            console.log(values);
            this.btnIsLoading=true;
            let result=await this.$http.post('/department/update', {id: this.id, ...values});
            this.btnIsLoading=false;
            if(result.data.status===1){
              this.visible = false;
              this.$message.success('操作成功！');
              this.getTableData({keyword: this.keyword});
            }
          }
        },
      );
    },
    // 取消编辑或新增
    onCancel() {
      this.visible = false;
    },
    // 修改排序
    async onCellChange(id, key, value){
      let result=await this.$http.post('/department/listOrder', {id: id, list_order: Number(value)});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ keyword: this.keyword});
      }
    },
    // 置顶
    async onTop(record) {
      console.log('TCL: onConfirm -> record', record);
      let result=await this.$http.post('/department/topChange', {id: record.id, is_top: record.is_top===1?0:1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ keyword: this.keyword});
      }
    },
    // 禁用 启用
    async onConfirm(record) {
      console.log('TCL: onConfirm -> record', record);
      let result=await this.$http.post('/department/statusChange', {id: record.id, status: record.status===1?0:1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ keyword: this.keyword});
      }
    },
    // 删除
    async onDelete(record) {
      let result=await this.$http.post('/department/del', {id: record.id});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ keyword: this.keyword});
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.section-container {
   .editable-cell-container{
    width: 60%;
  }
}
</style>
